<template>
  <div v-if="show"
       class="BoxPendencias pb-2 mx-2">
    <div v-if="false">
      <hr class="hr-errors">
      <div class="d-inline-flex align-items-center">
        <h3> Pendências 1</h3>
      </div>
      <hr class="hr-errors">
      <div class="d-inline-flex align-items-center">
        <p class="m-0 p-0 my-2">
          Precisa ter O.S para carga
        </p>

        <button class="btn btn-info btn--xs my-2 ml-3"
                @click="goToRegisterOS()">
          Cadastrar O.S
        </button>
      </div>
    </div>
    <div v-else-if="propErrors">
      <hr class="hr-errors">
      <div class="d-inline-flex align-items-center">
        <h3> Pendências </h3>
        <h6 class="ml-3">
          {{ Array.isArray(propErrors) ? propErrors.length : '1' }} nesse registro
        </h6>
      </div>
      <hr class="hr-errors">
      <div v-if="Array.isArray(propErrors)"
           class="my-2">
        <ul v-for="(error, index) in propErrors"
            :key="index"
            class="m-0 p-0 ml-3">
          <li>
            {{ error }}
            <button class="mr-1 btn btn-info btn--xs my-1"
                    @click="openRegister()">
              Ajustar
            </button>
          </li>
        </ul>
      </div>
      <div v-else
           class="my-2">
        {{ propErrors }}
        <button class="mr-1 btn btn-info btn--xs my-1"
                @click="openRegister()">
          Ajustar
        </button>
      </div>
    </div>
    <hr class="hr-errors mb-2">
    <div class="col-12 d-inline-flex justify-content-between m-0 p-0">
      <div class="d-inline-flex justify-content-between">
        <button v-if="propTarefa.tipo !== 'ANOTACAO'"
                class="btn-manual btn btn-outline-secondary px-4"
                @click="cumprirTarefaManual()">
          <IconSvg icon="touch"
                   class="icon--sm mr-2 icon-touch" />
          Envio Manual
        </button>
        <div v-else>
          <button class="btn-manual btn btn-outline-secondary px-4 mr-2"
                  @click="gerarAnotacao()">
            <IconSvg class="icon--sm mr-2 icon-pencil-anotacao"
                     icon="textSnippet" />
            Gerar Anotação
          </button>
          <button class="btn-manual btn btn-outline-secondary px-4"
                  @click="cumprirTarefaManual()">
            <IconSvg icon="touch"
                     class="icon--sm mr-2 icon-touch" />
            Anotação Manual
          </button>
        </div>
        <button v-if="propCasamento"
                class="btn btn-outline-secondary ml-2 px-4"
                @click="openResumo()">
          Ir para Habilitação
        </button>
      </div>
      <div class="btn-fechar">
        <button class="btn btn-outline-secondary btn-block px-4"
                @click="hide()">
          Fechar
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  /* services */
  import TarefasService from "@/services/Gerenciador/TarefasService"

  export default {
    name: 'BoxPendencias',
    props: {
      propErrors: {type: [Array, String], default: null},
      propTarefaId: {type: Number, default: null},
      propCasamento: {type: Boolean, default: false},
      propShowOs: { type: Boolean, default: false },
      propTarefa: {type: Object, default: null}
    },
    data () {
      return {
        show: false
      }
    },
    watch: {
      propTarefa () {
        this.show = false
      }
    },
    methods: {
      async cumprirTarefaManual () {

        const res = await displayMessage('question', 'Tem certeza que deseja cumprir manualmente essa tarefa?')

        if (!res.value) return

        try {
          loader({active: true})

          const res = await TarefasService.cumprirTarefaManual(this.propTarefaId)

          this.$emit('hide')

          await displayMessage('success', 'Sucesso!', res.message)

          this.$emit('reload')
        } catch ({response}) {
          const data = response ? response.data  : null
          const text = data ? data.message : 'Não foi possível cumprir a tarefa!'

          displayMessage('error', 'Error!', text)
        } finally {
          loader({active: false})
        }
      },
      hide () {
        this.show = false
      },
      openResumo () {
        this.$emit('openResumo')
      },
      goToRegisterOS () {
        this.$emit('goToRegisterOS')
      },
      openRegister () {
        this.$emit('openRegister')
      },
      showBox () {
        this.show = true
      },
      gerarAnotacao () {
        this.$emit('averbar')
      }
    }
  }
</script>
<style lang="scss">
 .hr-errors {
   background: #000 !important;
   margin: 0;
 }

 .icon-touch {
   fill: #1e4c89 !important;
 }

 .btn-manual:hover > [class*=icon-pencil-anotacao],
 .btn-manual:hover > [class*=icon-touch] {
    fill: #fff !important;
  }

  .icon-pencil-anotacao {
    fill: #1e4c89 !important;
  }
</style>
